export const initSkipHero = () => {
  const skipLinks = document.querySelectorAll('.skip-hero');
  if (!skipLinks.length) return;

  skipLinks.forEach((skipLink) => {
    skipLink.addEventListener('click', (event) => {
      event.preventDefault();

      const sectionToSkip =
        skipLink.closest('section.section') ||
        skipLink.parentElement?.parentElement ||
        skipLink.parentElement;

      if (!sectionToSkip) return;

      const nextSection =
        sectionToSkip.nextElementSibling instanceof HTMLElement
          ? sectionToSkip.nextElementSibling
          : null;
      const targetPosition = nextSection?.offsetTop ?? sectionToSkip.offsetTop + sectionToSkip.offsetHeight;

      const header =
        document.querySelector('.side-header') ||
        document.querySelector('.site-header');
      const headerHeight = header?.getBoundingClientRect().height ?? 0;
      const scrollAdjustment = headerHeight;
      window.scrollTo({
        top: Math.max(0, targetPosition - scrollAdjustment),
        behavior: 'smooth',
      });
    });
  });
};
